import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate, removeSpecialCharacter } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import { ROLE } from "../../../../utils/Constants";
import { detail } from "../../../doctor/services/patient.services";

const ViewPatient = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    {
      title: 'Patient Management',
      url: "/admin/patient-management/patient/list/1",
    },
    { title: t("admin.cafes.link_view"), url: "" },
  ];

  console.log("params",params.id)


  useEffect(() => {
     detail({ patient_id: params.id }, ROLE.SUPER_ADMIN)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              {/* <div>
                <h6 className="main-content-label mb-3">View Doctor</h6>
              </div> */}
              {showdefault && Object.keys(showdefault).length > 0 ? <div className='row'>
                <div className="col-lg-12 form-group">
                  <table id="simple-table" className="table  table-bordered table-hover">
                    <tbody>
                      <tr>
                        <th> {t("Patient ID")}</th>
                        <td className="text-capitalize">
                          {showdefault && showdefault.patient_register_id
                            ? '#' + (showdefault.patient_register_id)
                            : "N/A"}
                        </td>
                      </tr>

                      <tr>
                        <th>{t("Patient Name")}</th>
                        <td className="text-capitalize">
                          {showdefault && showdefault.name ? showdefault.name : "N/A"}
                        </td>
                      </tr>

                      <tr>
                        <th>{t("Email")}</th>
                        <td>
                          {showdefault && showdefault.email
                            ? showdefault.email
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Contact Number")}</th>
                        <td>
                          {showdefault && showdefault.phone_number
                            ? capitalizeFirstLetter(showdefault.phone_number)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("DOB")}</th>
                        <td>
                          {showdefault && showdefault?.dob
                            ? formateDate(showdefault.dob)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Gender")}</th>
                        <td>
                          {showdefault && showdefault.gender
                            ? capitalizeFirstLetter(showdefault.gender)
                            : "N/A"}
                        </td>
                      </tr>
                       <tr>
                        <th>{t("Address")}</th>
                        <td>
                          {showdefault && showdefault.address
                            ? capitalizeFirstLetter(showdefault.address)
                            : "N/A"}
                        </td>
                      </tr>
                        <tr>
                        <th>{t("Center ID")}</th>
                         <td>{showdefault?.centers?.map((center) => capitalizeFirstLetter(center?.center_register_id)).join(", ")}</td>
                      </tr>
                        <tr>
                        <th>{t("Center Name")}</th>
                        <td>{showdefault?.centers?.map((center) => capitalizeFirstLetter(center?.center_name)).join(", ")}</td>
                      </tr>
                      <tr>
                        <th>{t("Language Preference")}</th>
                        <td>
                          {showdefault && showdefault.language_preference
                            ? capitalizeFirstLetter(showdefault.language_preference)
                            : "N/A"}
                        </td>
                      </tr>
                       <tr>
                        <th>{t("Source Of Call")}</th>
                        <td>
                          {showdefault && showdefault.source_of_call
                            ? capitalizeFirstLetter(removeSpecialCharacter(showdefault.source_of_call))
                            : "N/A"}
                        </td>
                      </tr>
                      {showdefault && showdefault.source_of_call === "other" ? 
                        <tr>
                        <th>{t("Other(Source Of Call)")}</th>
                        <td>
                          {showdefault && showdefault.other_source_of_call
                            ? capitalizeFirstLetter((showdefault.other_source_of_call))
                            : "N/A"}
                        </td>
                      </tr> :null}
                        <tr>
                        <th>{t("Reason")}</th>
                        <td>
                          {showdefault && showdefault.reason
                            ? capitalizeFirstLetter((showdefault.reason))
                            : "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="mt-5">
                    <button className="btn ripple btn-dark" type='button' onClick={() => navigate(-1)}>
                      <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                      {t("admin.button.btn_back")}
                    </button>
                  </div>
                </div>
              </div> : <Loader />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewPatient;
